export default "Escapee åbnede i marts 2019.\n\nBemærk at ét af deres rum, \"Area 51\", kun er på dansk.";